<template>
  <section class="form__content">
    <h3>5. {{ $t('moreInformation.title') }}</h3>

    <v-radio-group v-if="completeChoice"
                   :label="$t('moreInformation.informationPayment.label')"
                   :value="informationPayment"
                   @change="$emit('update:informationPayment', $event)"
    >
      <v-radio v-for="information in informationPaymentValues"
               :key="information.value"
               :label="information.label"
               :value="information.value"
      />
    </v-radio-group>

    <v-switch v-else
              :label="$t('moreInformation.informationPayment.label')"
              :value="informationPayment"
              @change="$emit('update:informationPayment', $event)"
    />

    <v-radio-group :label="$t('moreInformation.informationNumber.label')"
                   :value="informationNumber"
                   @change="$emit('update:informationNumber', $event)"
    >
      <v-radio v-for="information in informationNumberValues"
               :key="information.value"
               :label="information.label"
               :value="information.value"
      />
    </v-radio-group>

    <v-text-field v-if="informationNumber === 'plusOne'"
                  :value="informationNumberAdults"
                  :label="$t('moreInformation.informationNumberAdults')"
                  @input="$emit('update:informationNumberAdults', $event)"
    />
    <v-text-field v-if="informationNumber === 'plusOne' && displayChildren"
                  :value="informationNumberChildren"
                  :label="$t('moreInformation.informationNumberChildren')"
                  @input="$emit('update:informationNumberChildren', $event)"
    />

    <v-textarea :label="$t('moreInformation.informationMessage')"
                :value="informationMessage"
                @input="$emit('update:informationMessage', $event)"
    />
  </section>
</template>

<script>
export default {
  name: 'MoreInformation',

  props: {
    completeChoice: {
      required: false,
      default: false,
    },
    displayChildren: {
      required: false,
      default: false,
    },
    informationMessage: {
      required: true,
    },
    informationNumber: {
      required: true,
    },
    informationNumberAdults: {
      required: true,
    },
    informationNumberChildren: {
      required: false,
      default: '',
    },
    informationPayment: {
      required: true,
    },
  },

  data () {
    return {
      informationNumberValues: [
        {
          label: this.$t('moreInformation.informationNumber.alone'),
          value: 'alone',
        },
        {
          label: this.$t('moreInformation.informationNumber.plusOne'),
          value: 'plusOne',
        },
      ],
      informationPaymentValues: [
        {
          label: this.$t('moreInformation.informationPayment.paymentResident'),
          value: 'paymentResident',
        },
        {
          label: this.$t('moreInformation.informationPayment.paymentUnistra'),
          value: 'paymentUnistra',
        },
        {
          label: this.$t('moreInformation.informationPayment.paymentOther'),
          value: 'paymentOther',
        },
      ],
    }
  },
}
</script>
